/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { NotificationCategoryFragmentDoc } from '../../../graphql/fragments/NotificationCategory.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SetUserNotificationPreferencesMutationVariables = Types.Exact<{
  input: Types.NotificationPreferencesInput;
}>;

export type SetUserNotificationPreferencesMutation = {
  readonly __typename?: 'Mutation';
  readonly setUserNotificationPreferences:
    | {
        readonly __typename: 'NotificationPreferencesError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'UserNotificationPreferences';
        readonly notificationCategories: ReadonlyArray<{
          readonly __typename: 'NotificationCategory';
          readonly id: string;
          readonly displayName: string;
          readonly emailSubscribe: boolean;
          readonly pushSubscribe: boolean;
          readonly hasResolved: boolean;
        }>;
      };
};

export const SetUserNotificationPreferencesDocument = gql`
  mutation SetUserNotificationPreferences($input: NotificationPreferencesInput!) {
    setUserNotificationPreferences(input: $input) {
      __typename
      ... on NotificationPreferencesError {
        errorMessage
        __typename
      }
      ... on UserNotificationPreferences {
        notificationCategories {
          ...notificationCategory
        }
      }
      ... on UserError {
        errorMessage
        __typename
      }
    }
  }
  ${NotificationCategoryFragmentDoc}
`;

export function useSetUserNotificationPreferencesMutation() {
  return Urql.useMutation<
    SetUserNotificationPreferencesMutation,
    SetUserNotificationPreferencesMutationVariables
  >(SetUserNotificationPreferencesDocument);
}
